import { render } from "./CinemasHalls.vue?vue&type=template&id=0b841947&scoped=true"
import script from "./CinemasHalls.vue?vue&type=script&lang=js"
export * from "./CinemasHalls.vue?vue&type=script&lang=js"

import "./CinemasHalls.vue?vue&type=style&index=0&id=0b841947&lang=scss&scoped=true"

import exportComponent from "D:\\main\\spacelab\\cinema-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b841947"]])

export default __exports__